import React from 'react'

const DevSkills = () => {
    return ( 
        <div className="left">

            <div className="about_title">
            <h3>Development Skills</h3>
            </div>
            

            <div className="tokyo_progress">
            <div className="progress_inner" data-value="95">
                <span>
                <span className="label">React JS</span>
                <span className="number">99%</span>
                </span>
                <div className="background">
                <div className="bar">
                    <div className="bar_in" style={{width: 99 + '%'}}></div>
                </div>
                </div>
            </div>

            <div className="progress_inner" data-value="80">
                <span>
                <span className="label">Java Script</span>
                <span className="number">99%</span>
                </span>
                <div className="background">
                <div className="bar">
                <div className="bar_in" style={{width: 99 + '%'}}></div>
                </div>
                </div>
            </div>

            <div className="progress_inner" data-value="90">
                <span>
                <span className="label">Type Script</span>
                <span className="number">99%</span>
                </span>
                <div className="background">
                <div className="bar">
                <div className="bar_in" style={{width: 99 + '%'}}></div>
                </div>
                </div>
            </div>

            <div className="progress_inner" data-value="90">
                <span>
                <span className="label">Vue</span>
                <span className="number">80%</span>
                </span>
                <div className="background">
                <div className="bar">
                <div className="bar_in" style={{width: 80 + '%'}}></div>
                </div>
                </div>
            </div>

            <div className="progress_inner" data-value="90">
                <span>
                <span className="label">HTML, CSS</span>
                <span className="number">99%</span>
                </span>
                <div className="background">
                <div className="bar">
                <div className="bar_in" style={{width: 99 + '%'}}></div>
                </div>
                </div>
            </div>

            </div>
            

        </div>
    );
}
 
export default DevSkills;